<template>
  <v-dialog
    v-model="dialog"
    light
    persistent
  >
    <v-card>
      <v-card-title class="px-4 py-2 primary-bg">
        {{ title }}
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="prio2"
          @click.native="close"
        >
          {{ $t('base.close') }}
        </v-btn>
      </v-card-actions>
      <v-card-text class="pa-4">
        <v-row v-if="hint != null">
          <v-col style="color:red">{{ hint }}</v-col>
        </v-row>
        <v-row
          class="primary lighten-5"
          v-if="dependencyObject.length > 0"
        >
          <v-col>Objekt</v-col>
          <v-col>Restwertgruppe</v-col>
          <v-col>Version</v-col>
          <v-col>gültig ab</v-col>
          <v-col>gültig bis</v-col>
          <!--<v-col>{{ item.payload }}</v-col>-->
        </v-row>
        <v-row
          v-for="(item, index) in dependencyObject"
          :key="index"
        >
          <v-col>{{item.object }}</v-col>
          <v-col>{{ item.rvGroupName }}</v-col>
          <v-col>{{ item.version }}</v-col>
          <v-col>{{ $filters.formatDateTime(item.validFrom) }}</v-col>
          <v-col>{{ $filters.formatDateTime(item.validTo) }}</v-col>
          <!--<v-col>{{ item.payload }}</v-col>-->
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="prio2"
          @click.native="close"
        >
          {{ $t('base.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="js">
export default {
  name: 'DependencyObjectDlg',
  data () {
    return {
      dialog: false,
      resolve: null,
      title: '',
      hint: null,
      dependencyObject: ''
    };
  },
  methods: {
    show (title, dependencyObject, hint = null) {
      this.title = title;
      this.hint = hint;
      this.dependencyObject = dependencyObject; // .sort((a, b) => a.timestamp < b.timestamp);
      this.dialog = true;

      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },

    close () {
      this.dialog = false;
      this.title = '';
      this.hint = null;
      this.dependencyObject = [];
      this.resolve(true);
    }

  }
};
</script>

<style scoped>
.v-btn {
  min-width: 64px !important;
}
</style>
